import React, { useEffect, useState } from 'react';
import UpDownArrow from './UpDownArrow';
import Select, { components } from 'react-select';
import PropTypes from "prop-types";


const ServiceLine = ({ serviceOptions }) => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isSafari = /safari/.test(userAgent) && !/chrome/.test(userAgent);
  const isWOS = /windows/i.test(userAgent)

  const selectClassName = isSafari ? 'service-dropdown service-dropdown-bg' : 'service-dropdown';

  const [selectedOption, setSelectedOption] = useState(serviceOptions);
  const [menuIsOpen, setmenuIsOpen] = useState(false);


  const updateServiceLineInput = selected => {
    const serviceLineInput = document.getElementById('service-line-cd');
    const selectedValues = selected ? selected.map(option => option.value) : [];
    serviceLineInput.value = selectedValues.join(',');
  };

  useEffect(() => {
    let serviceLineCd = sessionStorage.getItem('serviceLineCd');
    if (serviceLineCd) {
      serviceLineCd = JSON.parse(serviceLineCd);
      setSelectedOption(serviceLineCd);
      updateServiceLineInput(serviceLineCd);
    }
  }, []);

  const handleOnChange = selected => {
    updateServiceLineInput(selected);
    setSelectedOption(selected);
    sessionStorage.setItem('serviceLineCd', JSON.stringify(selected));
  };

  const handleOnClick = () => {
    setmenuIsOpen(!menuIsOpen)
  };

  const customValueContainer = ({ children, ...props }) => {
    const selectedCount = selectedOption.length;
    let displayValue = 'Select';
    if (selectedCount > 0) {
      displayValue = selectedCount > 1 ? `${selectedOption[0].label} + ${selectedCount - 1} items` : selectedOption[0].label;
    }
    return (
      <components.ValueContainer {...props} >
        {children.length > 0 ?
          <span className="value-displayed">{displayValue}</span>
          : <span className="value-displayed">  Select </span>}
      </components.ValueContainer>
    )
  }

  const customDropdownIndicator = ({ children, ...props }) => {
    return (
      <components.DropdownIndicator {...props}>
        <UpDownArrow />
      </components.DropdownIndicator>
    );
  }

  const customStyles = {
    option: (base, state) => ({
      base,
      color: isWOS ? "#333333" : "#dae1e7",
      padding: "5px 15px",
      backgroundColor: state.isSelected ? "#007aff" : "unset",
      ":hover": {
        backgroundColor: "#007aff",
      },
    }),
    menu: base => ({
      ...base,
      marginTop: 0,
      background: isWOS ? "#ffffff" : "#6a6867fa",
    }),
    indicatorSeparator: () => { }
  };

  return (
    <div onClick={handleOnClick}>
      <Select
        isMulti
        styles={customStyles}
        value={selectedOption}
        onChange={handleOnChange}
        options={serviceOptions}
        isSearchable={false}
        isClearable={false}
        menuIsOpen={menuIsOpen}
        components={{
          ValueContainer: customValueContainer,
          DropdownIndicator: isSafari ? customDropdownIndicator : components.DropdownIndicator
        }}
        hideSelectedOptions={false}
        className={selectClassName}
      />
    </div>
  );
};

ServiceLine.propTypes = {
  serviceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  ).isRequired
};

export default ServiceLine;
